import { Link } from 'react-router-dom'
import Submission from './Submission'
import SubmissionHeader from './SubmissionHeader'
import QuizHeader from './QuizHeader'
import NextButton from './NextButton'
import QuestionList from './QuestionList'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import { useSelector } from 'react-redux'

/*eslint-disable */

const ContentQuizView = ({ url, ...props }) => {
  const language = props.language || {}
  const dispatch = useDispatch()
  const { user } = useSelector((store) => store.auth)

  const [quiz, setQuiz] = useState(null)

  useEffect(() => {
    const pathArray = window.location.pathname.split('/')
    const contentQuizId = pathArray[pathArray.indexOf('content-quiz') + 1]

    dispatch(props.setContentQuizId(contentQuizId))
    dispatch(props.fetchContentQuizSubmission(contentQuizId, user?.id))

    AxiosInstance.get(`courses/content-quiz/${contentQuizId}`).then((data) => {
      if (data.passable) {
        console.log('quiz finished')
        dispatch(props.finishContent(props.course_id, contentQuizId))
      }
      dispatch(props.setCurrentContentQuiz(data))
      setQuiz(data)
    })

    // if (props.submitedContentQuiz) {
    // 	if (
    // 		!props.submitedContentQuiz.passable &&
    // 		props.submitedContentQuiz.quiz_passed == 1
    // 	) {
    // 		props.finishContent(props.course_id, contentQuizId)
    // 	}
    // }
  }, [window.location.pathname])

  return (
    <div>
      {props.submitedContentQuiz ? (
        <div>
          <div className='container-fluid'>
            <SubmissionHeader {...props} />
          </div>
          <div className='container-fluid'>
            <Submission {...props} />
          </div>
        </div>
      ) : null}
      {!props.submitedContentQuiz ? (
        <div className='container-fluid'>
          <QuizHeader {...props} quiz={quiz} />
          <QuestionList {...props} quiz={quiz} />
          <NextButton {...props} quiz={quiz} />
        </div>
      ) : null}
      {/* <Header
				cn='container-fluid'
				theme={props.theme.theme}
				language={props.language}
			> */}
      {/* {props.id ? (
					<Link to={`${url}/quiz?index=0`} className='btn btn-default'>
						<span className='btn-text'>
							{status === 1
								? language.courses
									? language.courses.view_submissions
									: null
								: status === -1
								? language.courses
									? language.courses.resume_quiz
									: null
								: language.courses
								? language.courses.take_quiz
								: null}
						</span>
					</Link>
				) : null} */}
      {/* 
				<Link to='/learning-plan' className='btn btn-default'>
					<span className='btn-text'>
						{language.general ? language.general.back : null}
					</span>
				</Link>
			</Header>

			<div>
				<div className='container-fluid'>
					<SubmissionHeader {...props} />
				</div>
				<div className='container-fluid'>
					<Submission {...props} />
				</div>
			</div> */}
    </div>
  )
}
export default ContentQuizView
